import { IconProps } from '../Icons.type'

export function StarIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19"
      fill="none"
      viewBox="0 0 20 19"
      {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.898.611c.317 0 .607.18.747.465L13.027 5.9l5.325.778a.833.833 0 01.46 1.422l-3.852 3.752.91 5.302a.833.833 0 01-1.21.878l-4.762-2.504-4.762 2.504a.833.833 0 01-1.21-.878l.91-5.302L.983 8.1a.833.833 0 01.461-1.422L6.77 5.9l2.38-4.824A.833.833 0 019.899.61zm0 2.716L8.07 7.03a.833.833 0 01-.626.456l-4.089.598 2.958 2.88a.833.833 0 01.24.738l-.698 4.07 3.655-1.923a.833.833 0 01.776 0l3.655 1.922-.698-4.069a.833.833 0 01.24-.738l2.958-2.88-4.088-.598a.833.833 0 01-.627-.456L9.898 3.327z"
        clipRule="evenodd"></path>
    </svg>
  )
}
